export default __webpack_public_path__ + "static/media/warning.471b873a.svg";